import { useEffect } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { useSelectedFilters } from '../../../../../controllers/filters/selected';
import {
	useCloudId,
	useSearchActions,
	useSelectedProduct,
	useThirdPartyConfigs,
} from '../../../../../controllers/store';

/**
 * This is a kind of a band-aid solution to deselect the product filter
 * in Quick Find. This is because when users interact with an inline product
 * filter (e.g. space filter), the primary product is set as the product filter.
 * Since there is no UI component to deselect the product filter, we end up in
 * a state where the product filter is selected without any UI indication. This
 * is problematic as the "Recent Activities" section in Quick Find becomes
 * unavailable whenever any filter is enabled.
 */
export const useUnselectProductFilter = () => {
	const [cloudId] = useCloudId();
	const [thirdPartyConfigs] = useThirdPartyConfigs();

	const [selectedProduct] = useSelectedProduct();
	const { selectedFilters } = useSelectedFilters({ cloudId, thirdPartyConfigs });
	const { unselectProductFilter } = useSearchActions();

	const confluenceSpacesFilterSelected = Boolean(
		selectedFilters.confluenceFilters.spacesFilter.length,
	);

	useEffect(() => {
		if (!fg('rovo_filters_discoverability')) {
			return;
		}

		// TODO: Make this smarter. Ideally, we should only unselect the product filter,
		// when that product filter is enabled and those product filters are empty. However
		// the isEmpty within useSelectedProduct is very very hard coded at the moment.
		if (selectedProduct === 'confluence' && !confluenceSpacesFilterSelected) {
			unselectProductFilter();
		}
	}, [confluenceSpacesFilterSelected, selectedProduct, unselectProductFilter]);
};
